import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const EpigenomicsPage = () => {
  return <TechnicalServicePage serviceKey="epigenomics" />
}

export default EpigenomicsPage
